/**
 * Adds `animate-in` to cards as they scroll into view.
 *
 * Ported from `public/index.html:676-690`: threshold 0.1, root margin
 * `0px 0px -50px 0px`, applied to `.feature-card`, `.capability-card`, and
 * `.team-card`. The class is never removed, so each card animates once.
 */
import { useEffect } from 'react';

const SELECTOR = '.feature-card, .capability-card, .team-card';

export const useScrollReveal = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('animate-in');
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll(SELECTOR).forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
};
